<div class="survey-notification-box risk-recheck">
  <div>
    <h4>{{ riskRecheck?.attributes.title }}</h4>
    <p class="xs-hide sm-hide">{{ riskRecheck?.attributes.body }}</p>
  </div>
  <div class="ui-button-group">
    <button routerLink="/strategy/risk-check" (click)="trackCTA('Notification Risk Recheck: [Button] Started')" class="ui-button">
      {{ 'new_strategy.notifications.risk_recheck.start' | translate }}
    </button>
    <button (click)="ignoreRecheck()" class="ui-button-text">
      {{ 'new_strategy.notifications.risk_recheck.dismiss' | translate }}
    </button>
  </div>
</div>
